import { AppBar, IconButton, Typography, Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import { AppStyle } from '../../helpers/appStyle';
import { appStyleMode } from '../../helpers/clientConfigs';

export const TextLogoImg = styled('img')({
  maxWidth: '30%',
});

export const LogoImg = styled('img')({
  marginLeft: '10px',
  cursor: 'pointer',
  '@media (max-width: 400px)': {
    width: appStyleMode === AppStyle.Formada ? '180px' : '150px',
    marginLeft: '0px',
  },
});

export const HomeItemsContainer = styled(Box)({
  flexGrow: 1,
  textAlign: 'right',
});

type CartBartTypographyProps = {
  isSmallFont: boolean;
};

export const CartBartTypography = styled(Typography)<CartBartTypographyProps>(({ isSmallFont }) => ({
  fontSize: isSmallFont ? '18px' : '24px',
  display: 'inline-block',
}));

export const BottomAppBar = styled(AppBar)(({ theme }) => ({
  top: 'auto',
  bottom: 0,
  backgroundColor: theme.palette.secondary.main,
  color: theme.palette.secondary.contrastText,
  height: '61px',
  width: '100%',
}));

export const SocialNetworkIconButton = styled(IconButton)(({ theme }) => ({
  color: theme.palette.appBar.bottom.color,
}));
